import React from "react";
import { Link } from "react-router-dom";

const NewFooter = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-8 px-8 mt-16">
      <div className="max-w-7xl mx-auto flex justify-between items-center flex-wrap gap-4">
        <p className="text-gray-500 text-sm">
          © 2026 HouseKeeper by FunSpex Limited. All rights reserved.
        </p>
        <div className="flex gap-8">
          <Link
            to="https://housekeeper.host/privacy"
            className="text-[#586989] no-underline text-sm hover:text-[#106A3A]"
          >
            Privacy Policy
          </Link>
          <Link
            to="https://housekeeper.host/terms"
            className="text-[#586989] no-underline text-sm hover:text-[#106A3A]"
          >
            Terms of Service
          </Link>
          <Link
            to="https://www.housekeeper.host/help"
            className="text-[#586989] no-underline text-sm hover:text-[#106A3A]"
          >
            Support
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
